import id from "./id";

export default {
  id: {
    date: {
      prixa: id.localizations.date
    },
    prixa: id.translations,
    time: {
      prixa: id.localizations.time
    }
  }
};
